import { convertRemoteToDesignSystemRole, } from "../enums/SDKDesignSystemRole";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class DesignSystem {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(
    // TODO: temp fix. For some reason is public is set to true in the model types
    model) {
        var _a, _b, _c;
        this.id = model.id;
        this.workspaceId = model.workspaceId;
        this.name = model.meta.name;
        this.description = (_a = model.meta.description) !== null && _a !== void 0 ? _a : "";
        this.isMultiBrand = model.isMultibrand;
        this.isPublic = model.isPublic;
        this.isApprovalFeatureEnabled = model.isApprovalFeatureEnabled;
        this.approvalRequiredForPublishing = model.approvalRequiredForPublishing;
        this.documentationExporterId = model.docExporterId;
        this.documentationSlug = model.docSlug;
        this.documentationUserSlug = (_b = model.docUserSlug) !== null && _b !== void 0 ? _b : null;
        this.designSystemSwitcher = (_c = model.designSystemSwitcher) !== null && _c !== void 0 ? _c : {
            isEnabled: false,
            designSystemIds: [],
        };
        this.accessMode = model.accessMode;
        this.effectiveRole = model.effectiveRole
            ? convertRemoteToDesignSystemRole(model.effectiveRole)
            : null;
        this.isAvailableToUser = model.isAvailableToUser;
        this.sharedDraftId = model.sharedDraftId;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using `fromTransport` */
    toTransport() {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            isPublic: this.isPublic,
            isMultiBrand: this.isMultiBrand,
            documentationSlug: this.documentationSlug,
            documentationUserSlug: this.documentationUserSlug,
            documentationExporterId: this.documentationExporterId,
            designSystemSwitcher: this.designSystemSwitcher,
            workspaceId: this.workspaceId,
        };
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        return new DesignSystem({
            id: model.id,
            meta: {
                name: model.name,
                description: model.description,
            },
            workspaceId: model.workspaceId,
            isMultibrand: model.isMultiBrand,
            docSlug: model.documentationSlug,
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            docUserSlug: model.documentationUserSlug,
            docExporterId: model.documentationExporterId,
            designSystemSwitcher: model.designSystemSwitcher,
        });
    }
}
